export default "__VITE_ASSET__BLPqebTa__"